import React, { useState, useEffect } from 'react';
import ErrorState from 'Admin/components/ErrorState';
import LoadingState from 'Admin/components/LoadingState';
import { GenGet } from 'state/api';

function VerVenda({ id }) {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [venda, setVenda] = useState({});

    const fetchData = async (endpoint, setter) => {
        try {
            const response = await GenGet(endpoint);
            setter(response);
        } catch (err) {
            setError(true);
        }
    };

    useEffect(() => {
        Promise.all([
            fetchData(`/venda/${id}`, setVenda),
        ]).then(() => setLoading(false));
    }, [id]);

    if (loading) {
        return <LoadingState />;
    }

    if (error) {
        return <ErrorState />;
    }

    return (
        <div className='p-2 flex flex-col gap-4'>
            <h1 className="text-[14pt] font-semibold p-0 m-0">Detalhes da Venda</h1>
            <div>
                <h2 className="text-[12pt] font-semibold p-0 m-0">Informações Gerais</h2>
                <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>ID da Venda:</strong> {venda.id}</p>
                <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Data:</strong> {venda.data}</p>
                <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Total:</strong> R$ {venda.total}</p>
                <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Modo de Pagamento:</strong> {venda.modo_pagamento}</p>
                <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Observações:</strong> {venda.observacoes || 'Nenhuma observação'}</p>
            <hr/>
            </div>

            <div>
                <h2 className="text-[12pt] font-semibold p-0 m-0">Cliente</h2>
                <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Nome:</strong> {venda.cliente.nome}</p>
                <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Telefone:</strong> {venda.cliente.contato_telefone_1}</p>
                <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Email:</strong> {venda.cliente.email}</p>
                <hr/>
            </div>

            <div>
                <h2 className="text-[12pt] font-semibold p-0 m-0">Profissional</h2>
                <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Nome:</strong> {venda.profissional.nome}</p>
                <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Email:</strong> {venda.profissional.email}</p>
                <hr/>
            </div>

            <div>
                <h2 className="text-[12pt] font-semibold p-0 m-0">Itens da Venda</h2>
                {venda.itens.map((item, index) => (
                    <div className="flex gap-2 p-2 border rounded-md" key={index}>
                        <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Item:</strong> {item.servico_produto.nome}</p>
                        <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Quantidade:</strong> {item.quantidade}</p>
                        <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Preço Unitário:</strong> R$ {item.preco_unitario}</p>
                        <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Total do Item:</strong> R$ {item.total_item}</p>
                    </div>
                ))}
            <hr/>
            </div>

            <div>
                <h2 className="text-[12pt] font-semibold p-0 m-0">Usuário Responsável</h2>
                <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Nome:</strong> {venda.usuario.name}</p>
                <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Email:</strong> {venda.usuario.email}</p>
                <p className="text-[10pt] font-semibold p-0 ml-2 my-0"><strong>Telefone:</strong> {venda.usuario.telefone}</p>
            <hr/>
            </div>
        </div>
    );
}

export default VerVenda;